'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../../core/render-with-ref.js';
import { RenderComp } from '../../core/render-comp.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, n = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), n.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
const H6 = renderWithRef('H6', null, (t, n)=>{
    let { children: o } = t;
    return jsx(RenderComp, {
        root: "h6",
        forwardedRef: n,
        classNames: [
            'swan-heading'
        ],
        props: _object_spread({
            fontSize: 'standard',
            fontWeight: 'bold'
        }, t),
        children: o
    });
});

export { H6 };
